import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IToolTip } from '../../../interface/interfaces';

interface IInitialState {
    showToolTip: boolean;
    toolTipContent: IToolTip;
}

export const toolTipContentInitial: IToolTip = { title: '', toolTip: [], color: 'dark', iconName: '', stretch: false, iconSize: 1.6, timer: 200, fixedSize: true };

const initialState: IInitialState = {
    showToolTip: false,
    toolTipContent: toolTipContentInitial,
};

const toolTipSlice = createSlice({
    name: 'toolTip',
    initialState,
    reducers: {
        showToolTip: (state: IInitialState, action: PayloadAction<IToolTip>) => {
            state.toolTipContent = action.payload;
            state.showToolTip = true;
        },

        hideToolTip: (state: IInitialState) => {
            state.showToolTip = false;
            state.toolTipContent = toolTipContentInitial;
        },
    },
});

export default toolTipSlice.reducer;
export const { showToolTip, hideToolTip } = toolTipSlice.actions;
